import { Divider, IconButton, ListItem, ListItemIcon, Menu, MenuItem } from "@mui/material"
import Tooltip from "components/material/tooltip"
import { Check, Clear, MoreVert } from "@mui/icons-material"
import moment from "moment"
import PropTypes from "prop-types"
import { useState } from "react"
import DeviceNameInput from "../device-name-input"
import "./style.scss"

export default function Device({ device, saveMfaDeviceName, deleteMfaDevice }) {
  const [menuAnchor, setMenuAnchor] = useState(null)
  const [isEditing, setIsEditing] = useState(false)

  const onSaveName = (name) => {
    saveMfaDeviceName(name, device.id)
    setIsEditing(false)
  }

  const onDeleteDevice = () => {
    setMenuAnchor(null)
    deleteMfaDevice(device.id)
  }

  return <div className="modules_user-profile_components_device">
    <Divider />
    <ListItem
      alignItems="flex-start"
      className="mfa-device"
      secondaryAction={<Tooltip title="Modify">
        <IconButton
          edge="end"
          onClick={ev => setMenuAnchor(menuAnchor ? null : ev.currentTarget)}
          size="large"
        >
          <MoreVert />
        </IconButton>
      </Tooltip>}
    >
      <span className="mfa-device-text">
        {isEditing
          ? <DeviceNameInput onSave={onSaveName} onCancel={() => setIsEditing(false)} initialValue={device.deviceName} />
          : <span className="mfa-device-name">{device.deviceName}</span>}
        <span className="mfa-device-date">{moment(device.createdAt).format("lll")}</span>
      </span>
      <Tooltip title={`Device ${device.verified ? "verified" : "was not verified"}`}>
        <ListItemIcon className="mfa-device-icon">
          {device.verified ? <Check /> : <Clear />}
        </ListItemIcon>
      </Tooltip>
    </ListItem>
    <Menu open={!!menuAnchor} onClose={() => setMenuAnchor(null)} anchorEl={menuAnchor}>
      <MenuItem onClick={() => {
        setMenuAnchor(null)
        setIsEditing(true)
      }}
      >
        Rename
      </MenuItem>
      <MenuItem
        className="danger"
        onClick={onDeleteDevice}
      >
        Remove
      </MenuItem>
    </Menu>
  </div>
}

Device.propTypes = {
  device: PropTypes.object.isRequired,
  saveMfaDeviceName: PropTypes.func.isRequired,
  deleteMfaDevice: PropTypes.func.isRequired,
}
